<template>
  <div>
    <Leads 
      @closeDialog="closeDialog"  
      :dialog="leadDialog"
    />
    <v-card-title>
      <span class="headline">Segmentação</span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Ex: nome"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="$store.state.leadSegmentations"
      class="elevation-1"      
      :search="search"
    >      
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.name">          
            <td>
              <v-badge                
                color="primary"
                :overlap="false"
                class="align-self-center"
              >
                <template v-slot:badge>
                  <span>{{item.leads_count}}</span>
                </template>
                {{item.name}}
              </v-badge>              
            </td>
            <td>
              <v-btn fab small color="secondary" title="Ver leads"                 
                @click="() => getSegmentLeads(item)">
                <v-icon>search</v-icon>
              </v-btn>
              <v-btn @click="remove(item.id)" title="Remover segmento" fab dark small color="error">
                <v-icon dark>remove</v-icon>
              </v-btn>
              <v-btn @click="edit(item)" fab dark small color="cyan">
                <v-icon dark>edit</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>    
  </div>
</template>

<script>  
  import Leads from './Leads.vue';
  export default {
    components: {
      Leads,
    },
    name: 'LeadSegmentationsList',
    created () {      
      this.fetchLeadSegmentations();
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchLeadSegmentations'
    },
    methods: {
      fetchLeadSegmentations() {        
        this.$store.dispatch('fetchLeadSegmentations');
      },
      closeDialog() {        
        this.leadDialog = false
      },
      formatStatus(status) {
        const reducer = (accumulator, currentValue) => accumulator + `<p>${currentValue.status}</p>`;
        return status.reduce(reducer, '');
      },
      remove(data) {
        if (confirm('Tem certeza que quer apagar?')) {
          this.$store.dispatch('deleteLeadSegmentation', {params: {id: data}})
        }
      },
      getSegmentLeads(item) {
        this.$store.dispatch('fetchSegmentationLeads', item);
        this.leadDialog = true;
      },
      edit(data) {        
        this.$emit('edit', data)
      }
    },
    data () {
      return {
        search: '',
        leadDialog: false,
        headers: [
          {text: 'Nome', value: 'name'},      
          {text: '', value: ''},
        ],
      }
    },
  }
</script>
<style lang="css" scoped>
</style>